export default {
	"1bfe098ef779f3115e373f10dd8734cd": "该商品下已存在更优惠的订单，待支付金额",
	"28b8eb041fa23be520e7d2e47b5bf270": "元",
	"2a7871065fc3ff143f5f895dd21fc06e": "去查看"
}
